/**
 * GET /jobs/{job_id}/files/{file_id}/pages/meta — 페이지 수 조회.
 *
 * 같은 PDF 는 immutable 이므로 staleTime 을 길게 (5분) 잡아 불필요한 재요청 방지.
 */

import { useQuery } from "@tanstack/react-query";

import { getPagesMeta, type PagesMeta } from "@/lib/api/file_images";

export const PAGES_META_QUERY_KEY = (jobId: string, fileId: string) =>
  ["pages-meta", jobId, fileId] as const;

export function usePagesMeta(jobId: string, fileId: string) {
  return useQuery<PagesMeta>({
    queryKey: PAGES_META_QUERY_KEY(jobId, fileId),
    queryFn: () => getPagesMeta(jobId, fileId),
    staleTime: 5 * 60_000,
  });
}
